import React, { useEffect, useState } from "react";
import Offcanvas from "react-bootstrap/Offcanvas";
import { Box, Typography, Rating, TextField } from "@mui/material";
import { MdNaturePeople } from "react-icons/md";
import { RxCross2 } from "react-icons/rx";
import Logo from "../../assets/images/Povital-Logo.png";
import {
  Timeline,
  TimelineItem,
  TimelineSeparator,
  TimelineConnector,
  TimelineDot,
  TimelineContent,
  timelineItemClasses,
} from "@mui/lab";
import { formatShortDateTime } from "../../utils/const";
import { useSelector } from "react-redux";

const HelpDeskDrawer = ({
  open,
  onClose,
  data,
  onReTicket,
  onRateTicket,
  helpdeskStatus,
}) => {
  const [rating, setRating] = useState(data?.rating || 0);
  const [showReTicketInput, setShowReTicketInput] = useState(false);
  const [reTicketReason, setReTicketReason] = useState("");

  const profile = useSelector((state) => state.profile?.data?.profile);

  const profilePicture = profile?.profile_picture;

  // Handle rating confirmation
  const handleConfirmRating = () => {
    if (onRateTicket && rating > 0) {
      onRateTicket({
        action: "rate_ticket",
        rating: rating,
        rate_comment: "good service",
      });
    }
  };
  useEffect(() => {
    setRating(data?.rating);
  }, [data?.rating]);
  console.log(rating);

  // Handle Re-Ticket click to show input field
  const handleReTicketClick = () => {
    setShowReTicketInput((prev) => !prev);
  };
  console.log(reTicketReason);

  // Handle Re-Ticket confirmation
  const handleConfirmReTicket = () => {
    if (onReTicket && reTicketReason.trim()) {
      onReTicket({
        action: "reopen_ticket",
        reason: reTicketReason,
      });
      setShowReTicketInput(false);
      setReTicketReason("");
    }
  };

  return (
    <Offcanvas
      show={open}
      onHide={onClose}
      placement="end"
      scroll={false}
      backdrop={false}
      style={{
        border: "none",
        marginTop: "65px",
        width: "60%",
        boxShadow: "-4px 0 10px rgba(0, 0, 0, 0.15)",
        backgroundColor: "#fff",
      }}
    >
      <Offcanvas.Body style={{ padding: 0, margin: 0 }}>
        <Box sx={{ px: "10px" }}>
          {/* Timeline Section */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              py: 2,
            }}
          >
            <Timeline
              sx={{
                [`& .${timelineItemClasses.root}:before`]: {
                  flex: 0,
                  padding: 0,
                },
                padding: "0 10px 0 10px",
              }}
            >
              {/* Queries Section */}
              <TimelineItem>
                <TimelineSeparator>
                  <TimelineConnector />
                  <TimelineDot sx={{ p: 0 }}>
                    <img
                      src={profilePicture}
                      alt="Logo"
                      style={{
                        width: "42px",
                        height: "42px",
                        padding: "1px",
                        backgroundColor: "#ffff",
                        objectFit: "contain",
                        borderRadius: "50%",
                      }}
                    />
                  </TimelineDot>
                  <TimelineConnector />
                </TimelineSeparator>
                <TimelineContent sx={{ py: "10px", px: 0, pl: "20px" }}>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "flex-start",
                    }}
                  >
                    <Box sx={{ width: "90%" }}>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          mb: 1,
                        }}
                      >
                        <Typography
                          sx={{
                            fontWeight: "bold",
                            fontSize: "16px",
                            textTransform: "capitalize",
                          }}
                        >
                          Your Queries:
                        </Typography>
                      </Box>
                      {Array.isArray(data?.facing_problem_in_module_name) &&
                        data.facing_problem_in_module_name.length > 0 && (
                          <Typography sx={{ mb: 0.5, fontSize: "14px" }}>
                            No 1: Facing problem in module:{" "}
                            <b>
                              {data.facing_problem_in_module_name.join(", ")}
                            </b>
                          </Typography>
                        )}
                      {data?.facing_problem_in_page_name && (
                        <Typography sx={{ mb: 0.5, fontSize: "14px" }}>
                          No 2: Facing problem in page/section:{" "}
                          <b>{data?.facing_problem_in_page_name}</b>
                        </Typography>
                      )}
                    </Box>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "flex-end",
                        mt: "20px",
                      }}
                    >
                      {data?.images?.length > 0 &&
                        data.images.map((src, index) => (
                          <a
                            key={index}
                            href={src?.image_url}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ marginRight: "5px" }}
                          >
                            <img
                              src={src?.image_url}
                              alt={`Query Image ${index + 1}`}
                              style={{
                                width: "50px",
                                height: "50px",
                                objectFit: "cover",
                                borderRadius: "3px",
                              }}
                            />
                          </a>
                        ))}
                    </Box>
                    <RxCross2
                      style={{
                        fontSize: "15px",
                        cursor: "pointer",
                        marginLeft: "10px",
                        marginBottom: "0",
                      }}
                      onClick={() => {
                        onClose();
                        if (data?.rating !== null) {
                          setRating(0);
                        }

                        setShowReTicketInput(false);
                        setReTicketReason("");
                      }}
                    />
                  </Box>
                </TimelineContent>
              </TimelineItem>
              {/* Staff Details and Admin Message Section */}
              {data?.ticket_assignments?.length > 0 && (
                <TimelineItem>
                  <TimelineSeparator>
                    <TimelineConnector />
                    <TimelineDot sx={{ p: 0 }}>
                      <img
                        src={Logo}
                        alt="Logo"
                        style={{
                          width: "42px",
                          height: "42px",
                          padding: "1px",
                          backgroundColor: "#ffff",
                          objectFit: "contain",
                          borderRadius: "50%",
                        }}
                      />
                    </TimelineDot>
                    <TimelineConnector />
                  </TimelineSeparator>
                  <TimelineContent sx={{ py: "10px", px: 0, pl: "20px" }}>
                    <Box
                      sx={{
                        border: "1.3px solid #e0e0e0",
                        borderRadius: "2px",
                        backgroundColor: "#fff",
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          p: "10px",
                          borderBottom: "1.3px solid #e0e0e0",
                        }}
                      >
                        <Box sx={{ display: "flex", gap: "20px" }}>
                          <Box>
                            <Typography
                              sx={{
                                fontSize: "14px",
                                // fontWeight: "bold",
                                textTransform: "capitalize",
                              }}
                            >
                              Role:{" "}
                              <b>
                                {data?.ticket_assignments[0]?.accepted_agent?.role
                                  ?.toLowerCase()
                                  ?.split("_")
                                  ?.map(
                                    (word) =>
                                      word.charAt(0).toUpperCase() +
                                      word.slice(1)
                                  )
                                  ?.join(" ")}
                              </b>
                            </Typography>
                          </Box>
                          <Box>
                            <Typography
                              sx={{
                                fontSize: "14px",
                                // fontWeight: "bold",
                                textTransform: "capitalize",
                              }}
                            >
                              Through:{" "}
                              <b>
                                {data?.ticket_assignments
                                  ?.flatMap((assignment) =>
                                    assignment?.assignment_notes?.map(
                                      (note) => note.connected_by
                                    )
                                  )
                                  ?.filter(Boolean)
                                  ?.join(`, `)}
                              </b>
                            </Typography>
                          </Box>
                        </Box>
                        <Typography
                          sx={{
                            // fontWeight: "bold",
                            fontSize: "14px",
                            textTransform: "capitalize",
                          }}
                        >
                          Dt: {console.log(data?.ticket_assignments[0])}
                          <b>
                            {formatShortDateTime(
                              data?.ticket_assignments
                                ?.flatMap((assignment) =>
                                  assignment?.assignment_notes?.map(
                                    (note) => note.updated_at
                                  )
                                )
                                ?.filter(Boolean)
                                ?.join(`, `)
                            )}
                          </b>
                        </Typography>
                      </Box>
                      <Box
                        sx={{
                          padding: "10px 0",
                          display: "flex",
                          justifyContent: "space-between",
                          p: "10px",
                        }}
                      >
                        <Typography sx={{ fontSize: "14px", mr: 1 }}>
                          {data?.ticket_assignments
                            ?.flatMap((assignment) =>
                              assignment?.assignment_notes?.map(
                                (note) => note.note
                              )
                            )
                            ?.filter(Boolean)
                            ?.join(`, `)}
                        </Typography>
                        <Box sx={{ display: "flex" }}>
                          {data?.ticket_assignments?.[0]?.assignment_notes?.[0]
                            ?.images?.length > 0 &&
                            data.ticket_assignments[0].assignment_notes[0].images.map(
                              (src, index) => (
                                <a
                                  key={index}
                                  href={src?.image_url}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  style={{ marginRight: "5px" }}
                                >
                                  <img
                                    src={src?.image_url}
                                    alt={`Query Image ${index + 1}`}
                                    style={{
                                      width: "50px",
                                      height: "50px",
                                      objectFit: "cover",
                                      borderRadius: "3px",
                                    }}
                                  />
                                </a>
                              )
                            )}
                        </Box>
                      </Box>
                    </Box>
                  </TimelineContent>
                </TimelineItem>
              )}
            </Timeline>
          </Box>
          {/* Rating and Action Buttons Section */}

          <Box sx={{ textAlign: "start", maxWidth: 370, ml: "20px" }}>
            {data.status === "closed" && (
              <Rating
                name="rating"
                value={rating}
                disabled={data.status !== "closed" || data?.rating !== null}
                precision={0.5}
                onChange={(event, newValue) => setRating(newValue)}
                sx={{
                  "& .MuiRating-icon": { fontSize: "34px", color: "#3856a6" },
                }}
                size="large"
              />
            )}
            {data.status === "closed" && (
              <Typography sx={{ mb: 2, fontSize: "14px" }}>
                Please rate on our executive and help us to improve our service
                quality in future
              </Typography>
            )}
            <Box sx={{ display: "flex", justifyContent: "start", gap: "15px" }}>
              {data?.rating === null && data?.status === "closed" && (
                <button
                  disabled={
                    rating === 0 ||
                    helpdeskStatus === "loading" ||
                    !(data?.rating === null && data?.status === "closed")
                  }
                  onClick={handleConfirmRating}
                  style={{
                    backgroundColor:
                      rating === 0 ||
                      helpdeskStatus === "loading" ||
                      !(data?.rating === null && data?.status === "closed")
                        ? "lightgray"
                        : "#3856a6",
                    padding: "10px 20px",
                    color: "#fff",
                    border: "none",
                    borderRadius: "4px",
                    cursor:
                      rating === 0 ||
                      helpdeskStatus === "loading" ||
                      !(data?.rating === null && data?.status === "closed")
                        ? "not-allowed"
                        : "pointer",
                    fontSize: "14px",
                    fontWeight: "bold",
                    textTransform: "capitalize",
                    minWidth: "120px",
                  }}
                >
                  {helpdeskStatus === "loading" ? "Loading..." : "Confirm"}
                </button>
              )}
              {data.status === "resolved" && (
                <button
                  onClick={handleReTicketClick}
                  disabled={
                    helpdeskStatus === "loading" || data.status !== "resolved"
                  }
                  style={{
                    backgroundColor:
                      helpdeskStatus === "loading" || data.status !== "resolved"
                        ? "lightgray"
                        : "#c55a11",
                    padding: "10px 20px",
                    color: "#fff",
                    border: "none",
                    borderRadius: "4px",
                    cursor:
                      helpdeskStatus === "loading" || data.status !== "resolved"
                        ? "not-allowed"
                        : "pointer",
                    fontSize: "14px",
                    fontWeight: "bold",
                    textTransform: "capitalize",
                    minWidth: "120px",
                  }}
                >
                  {helpdeskStatus === "loading" ? "Loading..." : "Re-Ticket"}
                </button>
              )}
            </Box>
            {showReTicketInput && (
              <Box sx={{ mt: 2 }}>
                <TextField
                  label="Reason for Re-Ticket"
                  value={reTicketReason}
                  onChange={(e) => setReTicketReason(e.target.value)}
                  fullWidth
                  multiline
                  rows={3}
                  variant="outlined"
                  sx={{ mb: 1 }}
                />
                <button
                  onClick={handleConfirmReTicket}
                  disabled={
                    !reTicketReason.trim() || helpdeskStatus === "loading"
                  }
                  style={{
                    backgroundColor: !reTicketReason.trim()
                      ? "lightgray"
                      : "#3856a6",
                    padding: "10px 20px",
                    color: "#fff",
                    border: "none",
                    borderRadius: "3px",
                    cursor: !reTicketReason.trim() ? "not-allowed" : "pointer",
                    fontSize: "14px",
                    marginBottom: 4,
                    fontWeight: "bold",
                    textTransform: "capitalize",
                    minWidth: "120px",
                  }}
                >
                  Confirm Re-Ticket
                </button>
              </Box>
            )}
          </Box>
        </Box>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default HelpDeskDrawer;
